import { trackScrollToEstimationBlock } from './tracking';
import { selectIsCommercial } from '../../../../../shared/selectors/offer';
import configsByCategoryForAreaPart from '../../../scripts/segment-inputs-config/configs-by-category/commercial-area-parts-v2';

export default [
  '$scope',
  'homeownerService',
  'config',
  'store',
  function ($scope, homeownerService, config, store) {
    this.isOwner = homeownerService.userCanPublishAdAsHomeownerInCurrentCategory;

    this.showPriceEstimator = false;
    this.isEstimationBlockScrollTracked = false;

    const updateBannerVisibility = () => {
      document.removeEventListener('scroll', trackEstimatorVisibilityByScroll);

      this.isEstimationBlockScrollTracked = false;

      const isValuationEstimateEnabled = !!config.get('addForm.ValuationPriceEstimate.Enabled');

      const isFlatRentOrSale =
        this.categoryInfo.objectType === 'flat' &&
        (this.categoryInfo.dealType === 'rent' || this.categoryInfo.dealType === 'sale');

      this.showPriceEstimator = isFlatRentOrSale && isValuationEstimateEnabled;

      if (this.showPriceEstimator) {
        document.addEventListener('scroll', trackEstimatorVisibilityByScroll);
      }
    };

    const trackEstimatorVisibilityByScroll = () => {
      const priceAndEstimationBlock = document.getElementById('price-and-deal-terms');

      if (priceAndEstimationBlock) {
        const rect = priceAndEstimationBlock.getBoundingClientRect();

        const isVisible = rect.bottom <= window.innerHeight;

        if (isVisible && !this.isEstimationBlockScrollTracked) {
          trackScrollToEstimationBlock();
          this.isEstimationBlockScrollTracked = true;
        }
      }
    };

    this.getTitleField = () => {
      const state = store.getState();
      const hasMultiAdBlock = configsByCategoryForAreaPart[this.ad.category];

      return hasMultiAdBlock && this.ad.areaParts && selectIsCommercial(state)
        ? 'Условия сделки'
        : 'Цена и условия сделки';
    };

    $scope.$watchGroup([() => this.categoryInfo.objectType, () => this.categoryInfo.dealType], updateBannerVisibility);
  },
];
